import { DatasetObjectQueryResponse } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DatasetTable from '../../components/DatasetTable';
import useAiAgentResponseTableConfig from './useAiAgentResponseTableConfig';

export type AiAgentResponseTableProps = {
  messageId: string;
  queryResponse: DatasetObjectQueryResponse;
};

const AiAgentResponseTable: React.FC<AiAgentResponseTableProps> = props => {
  const { t } = useTranslation('dataset');

  const columnsConfig = useAiAgentResponseTableConfig({
    columns: props.queryResponse.columns,
  });

  const isLoading = false;
  const itemsCount = _.size(props.queryResponse.result);
  const totalCount = itemsCount;

  return (
    <DatasetTable
      id={props.messageId}
      data={props.queryResponse.result}
      columnsConfig={columnsConfig}
      keyFields={[]}
      hasCounter
      hideScreenTitle={false}
      subtitle={t`Datasets`}
      title={''}
      isSticky
      onLoadNext={_.noop}
      onSearch={_.noop}
      totalCount={totalCount}
      searchValues={{}}
      isLoading={isLoading}
      className="block"
      hasRowCounter={itemsCount > 15}
    />
  );
};

export default AiAgentResponseTable;
